import React from 'react';
import classnames from 'classnames';
import s from './IconWrap.scss';
export var IconSize;
(function(IconSize) {
    /** 8px */ IconSize["NANO"] = "nano";
    /** 12px */ IconSize["TINY"] = "tiny";
    /** 16px */ IconSize["SMALLER"] = "smaller";
    /** 18px */ IconSize["SMALL"] = "small";
    /** 20px */ IconSize["COMPACT"] = "compact";
    /** 24px */ IconSize["MEDIUM"] = "medium";
    /** 32px */ IconSize["LARGE"] = "large";
    /** 36px */ IconSize["BIG"] = "big";
    /** 48px */ IconSize["HUGE"] = "huge";
    /** 96px */ IconSize["MEGA"] = "mega";
})(IconSize || (IconSize = {}));
export var IconPixelSize;
(function(IconPixelSize) {
    IconPixelSize[IconPixelSize["NANO"] = 8] = "NANO";
    IconPixelSize[IconPixelSize["TINY"] = 12] = "TINY";
    IconPixelSize[IconPixelSize["SMALLER"] = 16] = "SMALLER";
    IconPixelSize[IconPixelSize["SMALL"] = 18] = "SMALL";
    IconPixelSize[IconPixelSize["COMPACT"] = 20] = "COMPACT";
    IconPixelSize[IconPixelSize["MEDIUM"] = 24] = "MEDIUM";
    IconPixelSize[IconPixelSize["LARGE"] = 32] = "LARGE";
    IconPixelSize[IconPixelSize["BIG"] = 36] = "BIG";
    IconPixelSize[IconPixelSize["HUGE"] = 48] = "HUGE";
    IconPixelSize[IconPixelSize["MEGA"] = 96] = "MEGA";
})(IconPixelSize || (IconPixelSize = {}));
const IconWrap = ({ className, size = "medium", withPadding = false, condensed, customSizable = false, children, verticalAlign, disableDefaultColors, 'aria-hidden': ariaHidden, 'aria-label': ariaLabel, onAnimationEnd, containerRef })=>/*#__PURE__*/ React.createElement("span", {
        className: classnames(s['root'], !customSizable && s[size], withPadding && s['withPadding'], condensed && s['condensed'], verticalAlign && s[`vertical-align-${verticalAlign}`], !disableDefaultColors && s['default-colors'], className),
        "aria-hidden": ariaHidden,
        "aria-label": ariaLabel,
        onAnimationEnd: onAnimationEnd,
        ref: containerRef
    }, children);
IconWrap.displayName = 'IconWrap';
export default IconWrap;

//# sourceMappingURL=IconWrap.js.map